export const config = {
  propsName: 'renderProps',
  name: 'SpRadio',
  type: 'formTmpsConfig',
  icon: 'el-icon-document-checked',
  cnName: '单选框',
  base: {
    title: '单选框',
    //subtitle: 'SpSelect_subtitle',
    padded: true,
    flex: '1',
    margin: [0, 0, 0, 0],
    
  },
  props: [
    {
      type: 'el-switch',
      key: 'required',
      bind: {
        label: '是否必填'
      },
      value: false
    },
    {
      type: 'el-input',
      key: 'title',
      bind: {
        label: '单选框名称',
        placeholder: '请输入名称'
      },
      value: '单选框名称'
    },
    {
      type: () => import('@/weappTmps/comps/addOptions/index.vue'),
      cmpPath: '/comps/addOptions/index.vue',
      key: 'selectVal',
      bind: {
        label: ''
      },
      value: {
        addOptions: []
      }
    }
  ]
}
